import React from "react";
import { useSelector } from "react-redux";
import { smartengageSeletor } from "../../redux/selector";
import useCarousel from "../../../../../shared/containers/useCarousel/useCarousel";
import * as S from "./SmartEngage.styles";
import Icon from "../../../../../stories/core-components/IconsSelector";
import Smartengagebanner from "../../../../../stories/components/cars/ResultsPage/Smartengagebanner/Smartengagebanner";

const SmartengageBanner = () => {
  const gotribeResults = useSelector(smartengageSeletor);
  if (!gotribeResults?.length) return null;
  const len = gotribeResults?.length === 1 ? 1 : 2;
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(gotribeResults, len);
  return (
    <S.Wrapper flexDirection={len === 1 ? 'column': 'row'}>
      {dataList?.map((data, index) => (
        <Smartengagebanner {...data} index={index} setWidth={!!(index === 0 && len === 1) ? '100%' : '38.5rem'}/>
      )) || null}
      {isRightCursorActive ? (
        <S.SliderArrow
          className="right"
          onClick={() => {
            increment();
          }}
        >
          <Icon name="ArrowRightIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
      {isLeftCursorActive ? (
        <S.SliderArrow
          className="left"
          onClick={() => {
            decrement();
          }}
        >
          <Icon name="ArrowLeftIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
    </S.Wrapper>
  )
    ;
};

export default SmartengageBanner;
